import { Directive, Input, ElementRef, Renderer2, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[appJsonFormatter]'
})
export class JsonFormatterDirective implements OnChanges {
    @Input() appJsonFormatter: any; // Input to receive the JSON data

    constructor(private el: ElementRef, private renderer: Renderer2) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['appJsonFormatter'] && this.appJsonFormatter) {
            this.formatAndDisplayJson(this.appJsonFormatter);
        }
    }

    private formatAndDisplayJson(data: any): void {
        const formattedJson = JSON.stringify(data, null, 2); // Pretty-print JSON with 2 spaces indentation
        this.renderer.setProperty(this.el.nativeElement, 'innerHTML', `<pre>${formattedJson}</pre>`);
    }
}